import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { EmailForgotComponent } from './auth/email-forgot/email-forgot.component';
import { ChangePasswordComponent} from  './auth/change-password/change-password.component';
import { VerifyCodeComponent } from './auth/verify-code/verify-code.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { CivilLiabilityInsurancePageComponent } from './pages/civil-liability-insurance-page/civil-liability-insurance-page.component';
import { PaymentStatusComponent } from './pages/payment-status/payment-status.component';
import { loginGuard } from './auth/login.guard';

export const routes: Routes = [
  { path: 'terms', component: TermsPageComponent },
  { path: 'civil-liability-insurance', component: CivilLiabilityInsurancePageComponent },
  {
    path: '',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'email-forgot-password',
    component: EmailForgotComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'verify-code',
    component: VerifyCodeComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.routes)
  },
  {
    path: 'payment-status',
    component: PaymentStatusComponent
  },
];
